// the nice-number scale ends in 2.5, which only divides whole across five
export const TICK_DIVISIONS : number = 5;

// rounds an axis maximum up to 1, 2, 2.5, 5 or 10 times a power of ten
export function niceCeil ( value : number ) : number {
  if ( value <= 0 ) {
    return 1;
  }

  const power  : number = Math.pow(10, Math.floor(Math.log(value) / Math.LN10));
  const scaled : number = value / power;
  const nice   : number = scaled <= 1
    ? 1
    : scaled <= 2
      ? 2
      : scaled <= 2.5
        ? 2.5
        : scaled <= 5
          ? 5
          : 10;

  return nice * power;
}
